import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const paySttingsRouter: RouteConfig = {
  path: "/paySettings",
  component: Layout,
  meta: {
    title: "支付设置",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
    {
      path: "pay-settings",
      name:'pay-setting',
      component: () =>
        import(
          /* webpackChunkName: "pay-settings" */ "@/views/pay-settings/index.vue"
        ),
      meta: {
        title: "VIP支付管理",
        permission: "Pages.Settings"
      }
    },
    {
      path: "Payment-setting",
      name:'Payment-setting',
      component: () =>
        import(
          /* webpackChunkName: "pay-settings" */ "@/views/pay-settings/paymentSetting/index.vue"
        ),
      meta: {
        title: "智慧校园年服务费收款码金额配置",
        permission: "Pages.Settings"
      }
    },
    {
      path: 'qrServiceChargeSetting',
      name: 'QRServiceChargeSetting',
      component: () =>
        import(
          /* webpackChunkName: "pay-settings" */ "@/views/qrServiceChargeSetting/index.vue"
        ),
      meta: {
        title: "二维码年服务费",
        permission: "Pages.Payment"
      }
    },
    {
      path: 'unicomRegistration',
      name: 'unicomRegistration',
      component: () =>
        import(
          /* webpackChunkName: "pay-settings" */ "@/views/unicomRegistration/index.vue"
        ),
      meta: {
        title: "联通登记管理",
        // permission: "Pages.Payment"
      }
    },
    {
      path: 'expirationReminderSettings',
      name: 'expirationReminderSettings',
      component: () =>
        import(
          /* webpackChunkName: "pay-settings" */ "@/views/expirationReminderSettings/index.vue"
        ),
      meta: {
        title: "微信小程序会员到期提示",
        permission: "Pages.Payment"
      }
    },
    {
      path: "unicomRegistration/recordSchool",
      name: "recordSchool",
      component: () =>
        import(
          "@/views/unicomRegistration/components/recordSchool.vue"
        ),
      meta: {
        title: "登记记录",
        hidden: true,
      }
    },
    {
      path: "unicomRegistration/recordSchool/recordSchoolRegistration",
      name: "recordSchoolRegistration",
      component: () =>
        import(
          "@/views/unicomRegistration/components/recordSchoolRegistration.vue"
        ),
      meta: {
        title: "登记办理",
        hidden: true,
      }
    }, {
      path: "unicomRegistration/allSchoolRecord",
      name: "allSchoolRecord",
      component: () =>
        import(
          "@/views/unicomRegistration/components/allSchoolRecord.vue"
        ),
      meta: {
        title: "总登记办理",
        hidden: true,
      }
    }, 
    {
      path: "unicomRegistration/advertisingSpace",
      name: "advertisingSpace",
      component: () =>
        import(
          "@/views/unicomRegistration/advertisingSpace/index.vue"
        ),
      meta: {
        title: "广告位",
        hidden: true,
      }
    },
    // {
    //   path: "unicomRegistration/recordSchool/recordSchoolUnsubscribe",
    //   name: "recordSchoolUnsubscribe",
    //   component: () =>
    //     import(
    //       "@/views/unicomRegistration/components/recordSchoolUnsubscribe.vue"
    //     ),
    //   meta: {
    //     title: "申请退订",
    //     hidden: true,
    //   }
    // },
  ]
};

export default paySttingsRouter;
